export default "__VITE_ASSET__DQ1sarIn__"